<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close(formRef)"
    >
      <el-form ref="formRef" label-width="120px" :model="form" :rules="rules">
        <!-- 门店 -->
        <el-form-item label="门店" prop="branchId">
          <el-select
            v-model="form.branchId"
            placeholder="请选择门店"
            class="fix-width"
            clearable
            :disabled="!!form.roomTypeId"
          >
            <el-option
              v-for="item in branchList"
              :key="item.branchId"
              :label="item.title"
              :value="item.branchId"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 酒店 -->
        <el-form-item label="酒店" prop="hotelId">
          <el-select
            v-model="form.hotelId"
            placeholder="请选择酒店"
            class="fix-width"
            clearable
            :disabled="!!form.roomTypeId"
          >
            <el-option
              v-for="item in hotelList"
              :key="item.hotelId"
              :label="item.title"
              :value="item.hotelId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="上架状态">
          <el-radio-group v-model="form.step" size="mini">
            <el-radio-button :label="1">未上架</el-radio-button>
            <el-radio-button :label="2">上架</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="封面" prop="avatar">
          <el-upload
            class="avatar-uploader"
            :show-file-list="false"
            :action="QNUploadURL"
            :data="uploadToken"
            :on-success="image_success"
            :on-remove="image_remove"
          >
            <img v-if="form.avatar" :src="form.avatar" class="avatar" />
            <i v-else class="avatar-uploader-icon el-icon-plus"></i>
          </el-upload>
          <span>建议尺寸：750px * 360px</span>
        </el-form-item>
        <el-form-item label="轮播图" prop="imageList">
          <el-upload
            :action="QNUploadURL"
            :data="uploadToken"
            list-type="picture-card"
            :file-list="form.imageList"
            :on-success="imageList_success"
            :on-remove="imageList_remove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注" prop="text">
          <el-input
            v-model="form.text"
            type="textarea"
            class="fix-width"
            placeholder="请输入备注"
          />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close(formRef)">取 消</el-button>
        <el-button type="primary" @click="save(formRef)">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createRoomType, updateRoomType } from '@/api/room'
import { getUploadToken } from '@/api/app'
import { QNUploadURL, QNHost } from '@/config/net.config'
import { getAllBranchs } from '@/api/branch'
import { ref, reactive, getCurrentInstance } from 'vue'
import getHotel from '../hotel'
export default {
  name: 'RoomTypeEdit',
  emits: ['fetch-data'],
  setup(_, { emit }) {
    const { proxy } = getCurrentInstance()
    const title = ref('')
    const uploadToken = reactive({
      token: '',
    })
    const branchList = reactive([])
    const dialogFormVisible = ref(false)
    const formRef = ref(null)
    const initForm = () => {
      return {
        roomTypeId: '',
        title: '',
        branchId: '',
        hotelId: '',
        avatar: '',
        imageList: [],
        text: '',
        step: 2,
        order: 1,
        typehood: 1,
      }
    }
    const form = reactive(initForm())
    const { hotelList } = getHotel()
    const rules = {
      title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
      branchId: [{ required: true, trigger: 'blur', message: '请选择门店' }],
      hotelId: [{ required: true, trigger: 'blur', message: '请选择酒店' }],
      avatar: [
        {
          required: true,
          validator: (_, value, callback) => {
            if (value.length == 0) {
              callback(new Error('请上传封面'))
            } else {
              callback()
            }
          },
        },
      ],
    }
    const getAllBranchList = async () => {
      const res = await getAllBranchs({})
      if (!res) return
      branchList.length = 0
      branchList.push(...res)
    }
    const showEdit = async (row) => {
      if (row && row.roomTypeId) {
        title.value = '修改房型'
        form.avatar = row.basic.avatar
        form.imageList = row.basic.imageList
        form.text = row.basic.text
        form.order = row.basic.order
        form.roomTypeId = row.roomTypeId
        form.title = row.title
        form.step = row.step
        form.hotelId = row.basic.hotelId
        form.branchId = row.extra.branchId
      } else {
        title.value = '新增房型'
      }
      getAllBranchList()
      dialogFormVisible.value = true
      const token = await getUploadToken({})
      uploadToken.token = token.token
    }
    const formReset = (formRef) => {
      if (!formRef) return
      formRef.resetFields()
      Object.assign(form, initForm())
    }
    const close = (formRef) => {
      formReset(formRef)
      dialogFormVisible.value = false
    }
    // 图片
    const imageList_remove = (_, fileList) => {
      form.imageList = fileList.map((e) => ({
        name: e.name,
        url: e.url,
      }))
    }
    const image_remove = () => {
      form.avatar = ''
    }
    const image_success = (res, _) => {
      if (!res.hash) {
        proxy.$message.error('图片上传失败')
        return
      }
      form.avatar = `${QNHost}/${res.hash}`
    }
    const imageList_success = (res, file) => {
      if (!res.hash) {
        proxy.$message.error('图片上传失败')
        return
      }
      form.imageList.push({
        name: file.name,
        url: QNHost + '/' + res.hash,
      })
    }
    const save = (formRef) => {
      if (!formRef) return
      formRef.validate(async (valid) => {
        if (valid) {
          const roomTypeId = form.roomTypeId
          const data = Object.assign({}, form)
          proxy.$baseConfirm(
            `你确定要${roomTypeId ? '修改' : '新增'}房型吗`,
            null,
            async () => {
              roomTypeId
                ? await updateRoomType(data)
                : await createRoomType(data)
              proxy.$baseMessage(
                `${roomTypeId ? '修改' : '新增'}房型成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              emit('fetch-data')
              close(formRef)
            }
          )
        } else {
          return false
        }
      })
    }
    //暴露子组件方法
    // defineExpose({
    //   showEdit,
    // })
    return {
      title,
      QNUploadURL,
      QNHost,
      uploadToken,
      branchList,
      formRef,
      form,
      rules,
      hotelList,
      dialogFormVisible,
      showEdit,
      getAllBranchList,
      close,
      imageList_remove,
      image_remove,
      image_success,
      imageList_success,
      save,
    }
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @include size;

    &.large {
      @include size(1, large);
    }
  }
}
.icon_avatar {
  width: 50px;
  height: 50px;
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
.el-icon-circle-plus-outline,
.el-icon-remove-outline {
  font-size: 32px;
  vertical-align: middle;
  cursor: pointer;
}

.el-icon-circle-plus-outline {
  color: #409eff;
}

.el-icon-remove-outline {
  color: #f56c6c;
  margin-left: 15px;
}

.mr-10 {
  margin-right: 10px;
}
.mb-10 {
  margin-bottom: 10px;
}
</style>
